import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { listenToCall, doCall, showWebphone } from '../actions/call';
import { callTimer, imgError } from '../utils/utils';
import noAvatar from '../assets/img/no-avatar.png';
import ringing from '../assets/img/ringing.svg';
import onCall from '../assets/img/onCall.svg';

class AgentPanelRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFilter: '',
			link_disabled: false,
		};
	}

	componentWillMount() {
		if (this.props.user.busy && this.props.user.startTime) {
			this.showTimer(this.props.user.id, this.props.user.startTime, 'onCall');
		}
		if (!this.props.user.availability && this.props.user.unavailableTime >= 0) {
			this.showTimer(this.props.user.id, this.props.user.unavailableTime, 'unavailable');
		}
		if (!this.props.user.busy && this.props.user.availability && this.props.user.unavailableTime >= 0) {
			this.showTimer(this.props.user.id, this.props.user.unavailableTime, 'available');
		}
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.user != this.props.user) {
			const { user: agent } = nextProps;

			if (agent.busy && agent.startTime) {
				this.showTimer(agent.id, agent.startTime, 'onCall');
			} else {
				if (!agent.busy && this.state[`timer${agent.id}_onCall`]) {
					clearInterval(this[`timer${agent.id}_onCall`]);
					this.setState({
						[`timer${agent.id}_onCall`]: null
					}, () => {
						this[`timer${agent.id}_onCall`] = null;
					});
				}
			}

			if (!agent.busy && !agent.availability && agent.unavailableTime >= 0) {
				this.showTimer(agent.id, agent.unavailableTime, 'unavailable');
			} else {
				if ((agent.busy || agent.availability) && this.state[`timer${agent.id}_unavailable`]) {
					clearInterval(this[`timer${agent.id}_unavailable`]);
					this.setState({
						[`timer${agent.id}_unavailable`]: null
					}, () => {
						this[`timer${agent.id}_unavailable`] = null;
					});
				}
			}

			if (!agent.busy && agent.availability && agent.unavailableTime >= 0) {
				this.showTimer(agent.id, agent.unavailableTime, 'available');
			} else {
				if ((agent.busy || !agent.availability) && this.state[`timer${agent.id}_available`]) {
					clearInterval(this[`timer${agent.id}_available`]);
					this.setState({
						[`timer${agent.id}_available`]: null
					}, () => {
						this[`timer${agent.id}_available`] = null;
					});
				}
			}
		}
	}

	componentWillUnmount() {
		if (this.state[`timer${this.props.user.id}_onCall`]) {
			clearInterval(this[`timer${this.props.user.id}_onCall`]);
		}
		if (this.state[`timer${this.props.user.id}_unavailable`]) {
			clearInterval(this[`timer${this.props.user.id}_unavailable`]);
		}
		if (this.state[`timer${this.props.user.id}_available`]) {
			clearInterval(this[`timer${this.props.user.id}_available`]);
		}
	}

	getTelephoneAvailability = (agent) => {
		let availability = {
			title: '',
			iconColor: ''
		};
		if (agent.busy && agent.didAnswer) {
			availability.title = this.props.translations.onCall[this.props.selectedLanguage];
			availability.iconColor = 'user-busy';
		}
		if (agent.busy && !agent.didAnswer) {
			if (typeof agent.didAnswer == 'undefined') {
				availability.title = this.props.translations.onCall[this.props.selectedLanguage];
			} else {
				availability.title = agent.type == "outgoing"
					? this.props.translations.callingTo[this.props.selectedLanguage]
					: this.props.translations.ringingFrom[this.props.selectedLanguage];
				availability.iconColor = 'user-busy';
			}
		}
		if (!agent.busy && !agent.availability) {
			availability.title = agent.reason || this.props.translations.unavailable[this.props.selectedLanguage];
			availability.iconColor = 'user-unavailable';
		}
		if (!agent.busy && agent.availability) {
			availability.title = this.props.translations.available[this.props.selectedLanguage];
			availability.iconColor = 'user-available';
		}
		return availability;
	}

	// check for user availability. if available then makes call
	// Llamar desde el Panel de Agentes y Supervisores.
	handlePhoneClick = (e) => {
		if(e.target.id !== "") {
            if (! this.state.link_disabled)
            {
                // console.log('CLICK no more!! Agent Pane Row');
                this.state.link_disabled = true;
                setTimeout(() => { 
                    this.state.link_disabled = false; 
                    // console.log('CLICK ok!! Agent Panel Row'); 
                }, 5000);

    			const idArr = e.target.id.split('_');
    			const type = idArr[0];
    			const id = idArr[1];
    			const { extension, busy, call_id, didAnswer } = this.props[type].find(item => item.id == id);
                this.props.showWebphone(true);    			
    			if (!busy) {
    				if (extension !== this.props.agentInfo.extension) {
    					this.makeCall(extension);
    				}
    			} else {
    				if (extension !== this.props.agentInfo.extension && didAnswer) {
    					this.listenToCall(call_id);
    				}
    			}
			}
		}
	}

	makeCall = (phoneNumber) => {
		const payload = {
			phoneNumber,
			internalCall: true
		};
		this.props.doCall(payload);
	}

	showTimer = (id, startTime, type) => {
		
		if (!this[`timer${id}_${type}`] && startTime > 0) {
			const currentTime = moment();
			const startTimeObj = moment(startTime * 1000);
			let sec = currentTime.diff(startTimeObj, 'seconds');
			sec = Math.max(0, sec);

			this[`timer${id}_${type}`] = setInterval(() => {
				if (sec < (24 * 3600)) {
					sec = moment().diff(startTimeObj, 'seconds');
					sec = Math.max(0, sec);
					this.setState({
						[`timer${id}_${type}`]: callTimer(sec)
					});
				}
				else {
					clearInterval([`timer${id}_${type}`]);
					this.setState({ [`timer${id}_${type}`]: -1 });
				}
			}, 1000);
		}

		if (startTime == 0) {
			this.setState({
				[`timer${id}_${type}`]: '-:-'
			});
		}
	}

	render() {
		const {
			user,
			availability,
			type,
			translations,
			selectedLanguage
		} = this.props;
		return (
			<tr key={user.id}>
				<td style={{ width: '60%' }}>
					<div className="user-icon pull-left">
						<img
							className={`img-rounded ${user.online ? '' : 'img_grayscale'}`}
							src={user.avatar || noAvatar}
							onError={imgError}
							alt="Eugeni Sánchez"
						/>
					</div>
					<div className="pull-left" style={{ wordBreak: 'break-all', width: 'calc(100% - 33px)' }}>{user.extension} - {`${user.name} ${user.surname_1}`}</div>
				</td>
				{(user.online || user.busy) && <td className="text-right" style={{ width: '40%' }}>
					<a
						title={this.getTelephoneAvailability(user).title}
						id={`${type}_${user.id}`}
						onClick={this.handlePhoneClick}
						style={{ cursor: user.busy ? 'default' : 'pointer' }}
						className={`btn btn-link btn-lg user-status ${this.getTelephoneAvailability(user).iconColor} btn-icon`}
					>
						{!user.busy && <span id={`${type}_${user.id}`} className="icon icon-phone" />}
						{(user.busy && !user.didAnswer && typeof user.didAnswer != 'undefined') && <img src={ringing} height="24" alt="" />}
						{(user.busy && (user.didAnswer || typeof user.didAnswer == 'undefined')) && <img src={onCall} height="24" alt="" />}
					</a>
					{(user.busy && user.startTime) && <span>
						{(this.state[`timer${user.id}_onCall`] != -1) ? this.state[`timer${user.id}_onCall`] : translations.morethan24hr[selectedLanguage]}
					</span>}
					{(availability !== 'available' && user.unavailableTime >= 0 && !user.busy) && <span>
						{(this.state[`timer${user.id}_unavailable`] != -1) ? this.state[`timer${user.id}_unavailable`] : translations.morethan24hr[selectedLanguage]}
					</span>}
					{(!user.busy && user.availability && user.unavailableTime >= 0) && <span>
						{(this.state[`timer${user.id}_available`] != -1) ? this.state[`timer${user.id}_available`] : translations.morethan24hr[selectedLanguage]}
					</span>}
				</td>}
			</tr>
		);
	}
}

function mapStateToProps(state) {
	return {
		agents: state.agentsAndSupervisors.agents,
		supervisors: state.agentsAndSupervisors.supervisors,
		agentInfo: state.agentInfo,
		queuedCalls: state.queuedCalls.queuedCalls,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
	};
}

const mapDispatchToProps = {
	listenToCall,
	doCall,
	showWebphone
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentPanelRow);



// WEBPACK FOOTER //
// ./src/agent/AgentPanelRow.js